<template>
  <form @submit.prevent="update" novalidate autocomplete="off">
    <div class="columns">
      <div class="column is-one-fifth">
        <p class="has-text-weight-bold is-size-6 mb-sm">Shopify Notifications</p>
        <p class="has-text-grey is-size-7">
          Subscribe to push notifications to receive real-time alerts related to shopify events.
        </p>
      </div>
      <div class="column">
        <div v-if="!isLoading">
          <!-- Supplier Notifications -->
          <div v-if="context.isSupplier()">
            <div v-for="notification in supplierNotifications" :key="notification.action" class="mb-md">
              <PushNotification
                :notifications="pushNotifications"
                :action="notification.action"
                :title="notification.title"
                :text="notification.text" />
            </div>
          </div>
          <!-- Merchant Notifications -->
          <div v-else>
            <div v-for="notification in merchantNotifications" :key="notification.action" class="mb-md">
              <PushNotification
                :notifications="pushNotifications"
                :action="notification.action"
                :title="notification.title"
                :text="notification.text" />
            </div>
          </div>
        </div>
        <!-- while loading -->
        <div v-else>
          <div v-for="index in 2" :key="index">
            <div class="has-background-white pa-md rounded-lg mb-sm">
              <div class="mb-md">
                <b-skeleton width="25%" :animated="true"></b-skeleton>
                <b-skeleton width="75%" :animated="true"></b-skeleton>
              </div>
              <b-skeleton width="50%" height="30" :animated="true"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import PushNotification from './PushNotification'

export default {
  components: {
    PushNotification
  },
  computed: {
    ...mapGetters(['context']),
    merchantNotifications () {
      const notifications = []
      this.availableNotifications.forEach(notification => {
        if (notification.context.includes('retailer')) {
          notifications.push(notification)
        }
      })
      return notifications
    },
    supplierNotifications () {
      const notifications = []
      this.availableNotifications.forEach(notification => {
        if (notification.context.includes('supplier')) {
          notifications.push(notification)
        }
      })
      return notifications
    }
  },
  data () {
    return {
      availableNotifications: [{
        action: 'Shopify Order Skipped Due To Fraud Risk',
        title: 'Shopify Skipped Order',
        text: 'If you have any high/medium risk Shopify order that is skipped from importing, the platform will send notification to the distribution list specified below.',
        context: ['retailer']
      }]
    }
  },
  methods: {

  },
  mounted () {

  },
  props: {
    pushNotifications: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
